import PropTypes from 'prop-types';
import React from 'react';

import CustomSelect from '../CustomSelect';

const SelectBase = ({
  label,
  noOptionsMessage,
  selectedValue,
  onChange,
  options,
  placeholder,
  type,
  autoFocus,
  disabled,
  disableFuzzyMatch,
  fuseConfigKeys,
  getTerm,
  minCharSearchLength,
  displayError,
}) => {
  return (
    <div>
      <label className="desktop-d-helper">{label}</label>
      <CustomSelect
        noOptionsMessage={noOptionsMessage}
        initialValue={selectedValue}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        type={type}
        autoFocus={autoFocus}
        disabled={disabled}
        disableFuzzyMatch={disableFuzzyMatch}
        fuseConfigKeys={fuseConfigKeys}
        getTerm={getTerm}
        minCharSearchLength={minCharSearchLength}
        label={label}
        displayError={displayError}
      />
    </div>
  );
};

SelectBase.propTypes = {
  label: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  selectedValue: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    ),
  ]),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }),
  ).isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  disableFuzzyMatch: PropTypes.bool,
  fuseConfigKeys: PropTypes.arrayOf(PropTypes.string),
  getTerm: PropTypes.func,
  minCharSearchLength: PropTypes.number,
  displayError: PropTypes.bool,
};

SelectBase.defaultProps = {
  label: '',
  noOptionsMessage: '',
  selectedValue: null,
  onChange: () => {},
  placeholder: 'Search',
  autoFocus: true,
  disabled: false,
  disableFuzzyMatch: false,
  fuseConfigKeys: ['label'],
  getTerm: () => {},
  minCharSearchLength: null,
  displayError: false,
};

export default SelectBase;
